
import { useFormik } from "formik";
import useCurrentUser from "hooks/useCurrentUser";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { emergencyService } from "services/emergency.service";
import * as Yup from 'yup';
import { geocodeByLatLng } from "react-google-places-autocomplete";
import GoogleMapModal from "../GoogleMapModal";
import addressicon from "../../../assets/images/address.svg";
import useCountries from "hooks/useCountries";


function NaturalDisaster(props) {
  const { show, handleClose } = props;
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userAddress, setUserAddress] = useState(null);
  const [readOnlyData, setReadOnlyData] = useState([])
  const [location, setLocation] = useState({
    lat: 0,
    lng: 0,
  });

  const { countries } = useCountries();

  const formik = useFormik({
    initialValues: {
      type: "Disaster",
      requesterName: "",
      requesterEmail: "",
      disasterType: "",
      description: "",
      address: '',
      latitude: "",
      longitude: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      requesterName: Yup.string().required("Please enter Full Name"),
      requesterEmail: Yup.string().required("Please enter Email"),
      disasterType: Yup.string().required("Please enter Disaster Type"),
      description: Yup.string().required("Please enter Description")
    }),
    onSubmit: async (values) => {
      if (!values?.address || !values?.latitude || !values?.longitude) {
        setError('Please Enable Location!')
        return;
      }
      setIsLoading(true);
      try {
        const response = await emergencyService.addMissingPerson(values)
        setTimeout(() => {
          setIsLoading(false);
          toast.success(response?.data?.message)
          formik.resetForm()
          handleClose();
        }, 2000);
      } catch (err) {
        console.error(err?.response?.data?.message);
        setError(err?.response?.data?.message);
      }
    },
  });

  useEffect(() => {
    if (show) {
      navigator.geolocation.getCurrentPosition(position => {
        const { latitude, longitude } = position.coords;
        const pos = {
          lat: latitude,
          lng: longitude
        }
        if (pos?.lat && pos?.lng) {
          geocodeByLatLng(pos)
            .then(res => {
              formik.setFieldValue('address', res[0].formatted_address);
              formik.setFieldValue("latitude", pos.lat || "");
              formik.setFieldValue("longitude", pos.lng || "");
            })
            .catch(err => console.log(err))
        }
      }, (err) => {
        console.log('enable location')
      });
    }
  }, [navigator.geolocation, show]);

  const modalCloseHandler = () => {
    setShowModal(false);
  };

  return (
    <>


      <Modal
        show={show}
        className="modal-common alert-red-form"
        onHide={handleClose}
      >
        <Modal.Header className="text-center" closeButton>
          <p className="text-center mb-0">Natural Disaster</p>
        </Modal.Header>
        <Modal.Body >
          <form className="disaster-form" onSubmit={formik.handleSubmit} id="disasterForm">
            <div className="mb-30">
              <label className="py-2">Full Name</label>
              <br />
              <div className="form-control-bg">
                <input
                  type="text"
                  name="requesterName"
                  id="requesterName"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik?.values?.requesterName}
                  className="form-control rounded-3  w-100"
                  required
                />
              </div>
              {formik.touched.requesterName && formik.errors.requesterName ? (
                <span className="text-danger">{formik?.errors?.requesterName}</span>
              ) : null}
            </div>
            <div className="mb-30">
              <label className="py-2 ">Email</label>
              <br />
              <div className="form-control-bg">
                <input
                  type="text"
                  name="requesterEmail"
                  id="requesterEmail"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik?.values?.requesterEmail}
                  className="form-control rounded-3  w-100"
                  required
                />
              </div>
              {formik.touched.requesterEmail && formik.errors.requesterEmail ? (
                <span className="text-danger">{formik?.errors?.requesterEmail}</span>
              ) : null}
            </div>
            <div className="mb-30">
              <label className="py-2 ">Disaster Type</label>
              <br />
              <div className="form-control-bg">
                <input
                  type="text"
                  name="disasterType"
                  id="disasterType"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik?.values?.disasterType}
                  className="form-control rounded-3  w-100"
                  required
                />
              </div>
              {formik.touched.disasterType && formik.errors.disasterType ? (
                <span className="text-danger">{formik?.errors?.disasterType}</span>
              ) : null}
            </div>
            <div className="mb-10">
              <label className=" ">Description</label>
              <br />
              <div className="form-control-bg">
                <textarea
                  className="form-control"
                  name="description"
                  id="description"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}

                  value={formik?.values?.description}
                  rows="6"
                  maxLength={1000}
                ></textarea>
              </div>
              <label className="d-block text-end pt-1 pe-1">{formik.values.description.length}/1000</label>
              {formik.touched.description && formik.errors.description ? (
                <span className="text-danger">{formik?.errors?.description}</span>
              ) : null}
            </div>
            {error && <div className="text-danger mb-3">{error}</div>}



            <div className="mb-10">
              <label className="py-2">Address</label>
              <br />

              <div className="addres-icon rounded-3 bg-cyan w-100 px-3 py-3">
                <input
                  type="text"
                  placeholder="Enter Address"
                  className="w-100 bg-transparent border-0"
                  name="address"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.address}
                  readOnly
                />

                <img
                  onClick={() => setShowModal(true)}
                  alt='' src={addressicon}
                  className="cursor-pointer"
                />
              </div>
              {formik.touched.address && formik.errors.address ? (
                <span className="text-danger">{formik.errors.address}</span>
              ) : null}
            </div>

          </form>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="submit"
            form="disasterForm"
            className="btn btn-primary modal-red-btn text-capitalize w-100 text-white"
          >
            {isLoading ? "Loading..." : "Submit"}
          </button>
        </Modal.Footer>
      </Modal>
      <GoogleMapModal
        show={showModal}
        closeHandler={modalCloseHandler}
        setUserAddress={(address) => {
          setUserAddress(address)
          formik.setFieldValue('address', address)
        }}
        location={location}
        setLocation={setLocation}
        setReadOnlyData={setReadOnlyData}
        countries={countries}
        userAddress={userAddress}
      />
    </>
  );
}

export default NaturalDisaster;
